function appLandingSlider() {
  new Splide(".applanding-slider", {
    type: "loop",
    gap: 0,
    perPage: 3,
    autoplay: true,
    interval: 2000,
    arrows: false,
    perMove: 1,
    lazyLoad: "sequential",
    breakpoints: {
      768: { perPage: 1 },
    },
  }).mount();
}

document.addEventListener("DOMContentLoaded", appLandingSlider);
